import axios from 'axios';

const api = axios.create({ baseURL: '/api' });

api.interceptors.request.use(config => {
  const token = localStorage.getItem('platform_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    const isLoginReq = err.config?.url?.includes('/auth/login');
    const isLoginPage = window.location.pathname.includes('/login');

    if (err.response?.status === 401 && !isLoginReq && !isLoginPage) {
      localStorage.removeItem('platform_token');
      localStorage.removeItem('platform_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
